export default __webpack_public_path__ + "static/media/Aegis of Five Mercies.b1c090eb.jpg";